import React from "react";

export const Balloons = ({
  ignoreTitle,
  title = "Balloons icon",
  ...props
}) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 33.277 33.277"
    xmlSpace="preserve"
    className="balloons"
    {...props}
  >
    {!ignoreTitle ? <title>{title}</title> : null}
    <path
      d="M11.246,18.75c1.122,3.728,1.396,7.667,1.222,11.541c-0.023,0.472,0.621,0.173,0.636-0.171
    c0.178-3.924-0.089-7.926-1.226-11.703C11.753,18.003,11.15,18.428,11.246,18.75z M21.456,22.114
    c0.277,0.991,0.081,2.011,0.14,3.023c0.078,1.353,0.907,2.392,1.919,3.219c0.062-0.197,0.128-0.393,0.193-0.589
    c-0.926,0.402-2.413,1.068-2.334,2.307c0.069,1.067,0.883,1.831,0.692,2.968c-0.079,0.459,0.579,0.161,0.636-0.17
    c0.146-0.849-0.134-1.577-0.472-2.34c-0.137-0.31-0.284-0.652-0.181-0.991c0.186-0.607,1.258-0.96,1.763-1.181
    c0.181-0.079,0.393-0.427,0.192-0.589c-1.039-0.852-1.749-1.833-1.789-3.207c-0.027-0.941,0.132-1.858-0.129-2.782
    C21.971,21.366,21.367,21.791,21.456,22.114z M21.689,3.437c-4.065,0-7.364,4.191-7.364,9.362c0,5.169,5.493,9.736,7.364,9.736
    c1.874,0,7.365-4.566,7.365-9.736C29.054,7.628,25.757,3.437,21.689,3.437z M23.63,6.278l1.358-0.612
    c4.159,4.383,1.037,7.747,1.037,7.747C27.453,9.335,23.63,6.278,23.63,6.278z M12.336,18.583h-0.995c0,0-0.169,0.938-0.611,1.223
    c-0.441,0.286,1.261-0.665,1.956-0.026C12.565,19.674,12.138,19.243,12.336,18.583z M12.686,19.78
    c0.02,0.018,0.032,0.026,0.032,0.026C12.707,19.797,12.695,19.79,12.686,19.78z M22.606,21.896h-0.994c0,0-0.17,0.937-0.61,1.223
    c-0.443,0.286,1.26-0.665,1.954-0.025C22.835,22.985,22.409,22.555,22.606,21.896z M22.955,23.093
    c0.021,0.016,0.033,0.025,0.033,0.025C22.978,23.109,22.967,23.102,22.955,23.093z M17.626,4.006C16.294,1.585,14.088,0,11.587,0
    C7.52,0,4.223,4.191,4.223,9.361s5.492,9.736,7.364,9.736c0.73,0,2.012-0.697,3.304-1.853c-0.869-1.433-1.472-3.073-1.472-4.78
    C13.419,8.731,15.139,5.509,17.626,4.006z M8.617,4.82C8.549,4.891,8.482,4.963,8.415,5.037C8.283,5.185,8.154,5.339,8.03,5.496
    c-0.25,0.315-0.479,0.646-0.689,0.99C6.922,7.174,6.592,7.919,6.412,8.705c-0.18,0.784-0.195,1.612-0.002,2.416
    c0.189,0.804,0.588,1.57,1.114,2.245c-0.621-0.588-1.149-1.302-1.482-2.126c-0.337-0.822-0.464-1.742-0.396-2.646
    C5.711,7.688,5.955,6.8,6.303,5.965c0.174-0.419,0.375-0.826,0.6-1.221C7.016,4.546,7.134,4.352,7.259,4.16
    c0.064-0.097,0.127-0.191,0.194-0.287c0.07-0.097,0.133-0.186,0.219-0.293l1.142,1.046C8.756,4.677,8.681,4.751,8.617,4.82z"
    />
  </svg>
);
